import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import closeIcon from "@assets/images/close.svg";
import { AssignDriverStyle } from "./style";
import moment from "moment";

function FuelSurchargePopup(props) {
  const classes = AssignDriverStyle();
  const [scroll] = useState("body");
  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.customModal}
      scroll={scroll}
    >
      <div className="close-modal">
        <img src={closeIcon} alt="Close" onClick={props.handleClose} />
      </div>
      {props.error && <Alert severity="error">{props.error}</Alert>}
      <DialogTitle id="alert-dialog-title">Scheduled fuel surcharge conflict</DialogTitle>
      <form
        noValidate
        autoComplete="off"
        className={classes.customForm}
      >
        <DialogContent>
          <div className="form-row">
            <div className="form-gourp">
              <span className="content">The Start Date <b>{ moment(props.dataFuelSurchargeConflict?.startDate).format("DD-MM-YYYY") }</b> for the rate <b>{ props.dataFuelSurchargeConflict?.newRate }%</b> you entered conflicts with an existing schedule rate of <b style={{ color: "red" }}>{ props.dataFuelSurchargeConflict?.existingScheduleRate }%</b> starting on <b>{ moment(props.dataFuelSurchargeConflict?.existingScheduleStartDate).format("DD-MM-YYYY") }</b> for { props.dataFuelSurchargeConflict?.customerName } - { props.dataFuelSurchargeConflict?.cityName }.</span>
              <div className="choose-proceed">Please choose how to proceed:</div>
              <Button
                className="primary-btn linkButton"
                color="inherit"
                disableElevation
                onClick={() => props.handleFuelSurchargeConflict({option: 1})}
              >
                Make new rate effective temporarily until the scheduled rate begins.
              </Button>
              <Button
                className="primary-btn linkButton"
                color="inherit"
                disableElevation
                onClick={() => props.handleFuelSurchargeConflict({option: 2})}
              >
                Make new rate effective and permanently replace the existing scheduled rate.
              </Button>
            </div>
          </div>
        </DialogContent>
        <DialogActions className="bottom-button-block">
          <Button
            className="orange-btn primary-btn center-loading-indicator"
            color="inherit"
            disableElevation
            onClick={props.handleClose}
          >CANCEL</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default FuelSurchargePopup;
